import { apiWithBody, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ApiDef_ContextRule, DBDef_ContextRule } from '@app/hcs-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onContextRulesUpdated = new ThunderDispatcherV3('__onContextRulesUpdated');
export class ModuleFE_ContextRule_Class extends ModuleFE_BaseApi {
    _v1;
    __searchFilterMapper = (item) => [item.label ?? item.description ?? '', item._id];
    __searchGroups = (items) => ([{
            group: this.dbDef.entityName,
            results: items.map(i => {
                return { _id: i._id, uiLabel: i.label };
            })
        }]);
    constructor() {
        super(DBDef_ContextRule, dispatch_onContextRulesUpdated);
        this._v1 = {
            compare: apiWithBody(ApiDef_ContextRule._v1.compare)
        };
    }
}
export const ModuleFE_ContextRule = new ModuleFE_ContextRule_Class();
//# sourceMappingURL=ModuleFE_ContextRule.js.map